
import request from '@/utils/request'
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function getallMemberApi(params) {
  return request({
    url: '?c=up&a=member&do=getall',
    method: 'get',
    params
  })
}

export function getfewMemberApi(params) {
  return request({
    url: '?c=up&a=member&do=getfew',
    method: 'get',
    params
  })
}

export function getMemberListApi(params) {
  return request({
    url: '?c=up&a=member&do=list',
    method: 'get',
    params
  })
}

export function getMemberProfileApi(params) {
  return request({
    url: jsApiHost + '/member/profile/get',
    method: 'get',
    params
  })
}

export function memberOrderApi(params) {
  return request({
    url: jsApiHost + '/member/order/list',
    method: 'get',
    params
  })
}

export function postMemberProfileApi(data) {
  return request({
    url: '?c=up&a=profile&do=post',
    method: 'post',
    data
  })
}

export function getMemberBindListApi(params) {
  return request({
    url: '?c=up&a=equip&do=list',
    method: 'get',
    params
  })
}

export function getBehavioractivationApi(params) {
  return request({
    url: '?c=up&a=behavior&do=activation',
    method: 'get',
    params
  })
}

export function customerPreCheckApi(params) {
  return request({
    url: jsApiHost + '/god/customer/member/preCheck',
    method: 'get',
    params
  })
}

export function customerSetApi(data) {
  return request({
    url: jsApiHost + '/god/customer/member/set',
    method: 'post',
    data
  })
}

